import React from 'react';
import { Link } from 'gatsby';

import './header.css';

function Header() {
  return (
    <>
      <div className="logo animated fadeInLeft">
        <a href="/" title="Home">
          <h1 style={{
            fontWeight: 300,
            fontSize: '5rem'
          }}>tob<span style={{
            color: '#19bc9c'
          }}>i</span>as
          </h1>
        </a>
      </div>
      <nav>
        <ul>
          <li>
            <Link to='/' activeClassName='active'>Home</Link>
          </li>
          <li>
            <Link to='/blog/' activeClassName='active' partiallyActive={true}>Blog</Link>
          </li>
          <li>
            <Link to='/portfolio/' activeClassName='active' partiallyActive={true}>Portfolio</Link>
          </li>
          <li>
            <Link to='/about/' activeClassName='active' partiallyActive={true}>About</Link>
          </li>
        </ul>
      </nav>
    </>
  )
}

export default Header;
